<ng-container *ngIf="showDiv && isAnsweredSurveyDisplay === undefined 
&& surveyScreenCodeDisplay !== screenCode">
	<div class="survey-grid grid-column-one-full card-block">		
		<span class="survey-header-title">
			<span translate>survey.header.title</span>&ngsp;
			{{ getSurveyScreenCodeTr(screenCode) | translate}}
		</span>
		<div>
			<button class="survey-answer-button" type="button" (click)="openSurveyAnswerDialog()" cdkFocusInitial mat-button>
				<span class="survey-button-label" translate>overview.survey-answer</span>
				<mat-icon iconPositionEnd svgIcon="md:forum" color="accent"></mat-icon>
			</button>
		</div>
		<div>
			<span translate>overview.survey.please</span>&#44;
			<span class="survey-text-bold" translate>overview.survey.questions</span>
		</div>
		<div class="survey-no-answer">
			<a (click)="$event.preventDefault();noAnswer()" class="no-answer-link" href="#" translate>overview.survey-no-answer</a>
		</div>
	</div>
</ng-container>